// extracted by mini-css-extract-plugin
export default {"backButtonBar":"s0S7aOcjQoGyldzyHE3r","container":"xA2MRw0l3VaIKOflZKBA","root":"q9UE3iiGw6Jb1W8cBS1o","title":"lHayiBvKVyjM6l44_Ahd"};